/** API / DB: always minutes. UI may show hours for values >= 60 when divisible by 60. */

export const PREPARATION_TIME_MINUTES = {
    MIN_15: 15,
    MIN_30: 30,
    MIN_45: 45,
    MIN_60: 60,
    HOUR_2: 120,
    HOUR_4: 240,
    HOUR_6: 360,
    HOUR_8: 480,
    HOUR_12: 720,
    HOUR_24: 1440,
    HOUR_48: 2880,
};

const BASE_OPTIONS = [
    PREPARATION_TIME_MINUTES.MIN_15,
    PREPARATION_TIME_MINUTES.MIN_30,
    PREPARATION_TIME_MINUTES.MIN_45,
    PREPARATION_TIME_MINUTES.MIN_60,
];

const MARKET_HOUR_OPTIONS = [
    PREPARATION_TIME_MINUTES.HOUR_2,
    PREPARATION_TIME_MINUTES.HOUR_4,
    PREPARATION_TIME_MINUTES.HOUR_6,
    PREPARATION_TIME_MINUTES.HOUR_8,
    PREPARATION_TIME_MINUTES.HOUR_12,
    PREPARATION_TIME_MINUTES.HOUR_24,
    PREPARATION_TIME_MINUTES.HOUR_48,
];

export function getPreparationTimeOptions(industry) {
    if (industry === 'markets') {
        return [...BASE_OPTIONS, ...MARKET_HOUR_OPTIONS];
    }
    return BASE_OPTIONS;
}

/** Send to backend: integer minutes (e.g. 2 hours → 120, not 2). */
export function preparationTimeForApi(minutes) {
    return Number(minutes);
}

export function formatDurationMinutes(minutes, t) {
    const m = Number(minutes);
    if (!m && m !== 0) return '';
    if (m <= 0) return `0 ${t('min')}`;

    const days = Math.floor(m / 1440);
    const hours = Math.floor((m % 1440) / 60);
    const mins = m % 60;
    const parts = [];

    if (days > 0) {
        parts.push(`${days} ${t('days')}`);
    }
    if (hours > 0) {
        parts.push(`${hours} ${t('hours')}`);
    }
    if (mins > 0 || parts.length === 0) {
        parts.push(`${mins} ${t('min')}`);
    }

    return parts.join(' ');
}

/** API / DB: always minutes. UI may show hours/days when appropriate. */
export function formatPreparationTimeLabel(minutes, t) {
    return formatDurationMinutes(minutes, t);
}
